import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ResetPasswordPage } from '@/pages/authentication/ui/ResetPasswordPage'

const resetPasswordSearchSchema = z.object({
  token: z.string().catch(''),
})

export const Route = createFileRoute('/reset-password')({
  validateSearch: resetPasswordSearchSchema,
  component: ResetPasswordPage,
})
